// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"AdminDriver_dashboard__1Qhxq","dashboard-main":"AdminDriver_dashboard-main__3sKIw","approvals":"AdminDriver_approvals__3h8ed","table":"AdminDriver_table__2V4PF"};